// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SupplementDetailsPopup-module__firstGrid___ze3EL {
  display: grid;
  padding: 15px 30px;
  grid-row-gap: 25px;
  grid-column-gap: 25px;
  grid-template-columns: repeat(3, 1fr);
}

.SupplementDetailsPopup-module__comments___HeWLv {
  margin: 10px 0;
  padding: 15px 30px;
}

.SupplementDetailsPopup-module__secondGrid___xy44C {
  display: grid;
  padding: 15px 30px 32px 30px;
  grid-row-gap: 25px;
  grid-column-gap: 25px;
  grid-template-columns: repeat(3, 1fr);
}`, "",{"version":3,"sources":["webpack://./src/popups/SupplementDetailsPopup/SupplementDetailsPopup.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qCAAA;AACF;;AAEA;EACE,cAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,4BAAA;EACA,kBAAA;EACA,qBAAA;EACA,qCAAA;AACF","sourcesContent":[".firstGrid {\n  display: grid;\n  padding: 15px 30px;\n  grid-row-gap: 25px;\n  grid-column-gap: 25px;\n  grid-template-columns: repeat(3, 1fr);\n}\n\n.comments {\n  margin: 10px 0;\n  padding: 15px 30px;\n}\n\n.secondGrid {\n  display: grid;\n  padding: 15px 30px 32px 30px;\n  grid-row-gap: 25px;\n  grid-column-gap: 25px;\n  grid-template-columns: repeat(3, 1fr);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"firstGrid": `SupplementDetailsPopup-module__firstGrid___ze3EL`,
	"comments": `SupplementDetailsPopup-module__comments___HeWLv`,
	"secondGrid": `SupplementDetailsPopup-module__secondGrid___xy44C`
};
module.exports = ___CSS_LOADER_EXPORT___;
